import { render, staticRenderFns } from "./RespostaCardCotacaoDetalhes.vue?vue&type=template&id=3c362d36"
import script from "./RespostaCardCotacaoDetalhes.vue?vue&type=script&lang=js"
export * from "./RespostaCardCotacaoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports